import { render, staticRenderFns } from "./CyCrkManage.vue?vue&type=template&id=37d37b30&scoped=true"
import script from "./CyCrkManage.vue?vue&type=script&lang=js"
export * from "./CyCrkManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d37b30",
  null
  
)

export default component.exports